import { useNavigate } from "react-router-dom";
import { useState } from "react";
import {
    Box,
    Button,
    Tabs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tab,
} from "@mui/material";



interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const ViewPurchaseServices = () => {
    const navigate = useNavigate();


    const [valueTabs, setValueTabs] = useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const [rows] = useState([
        {
            id: 1,
            name: "Alice Johnson",
            email: "alice.johnson@example.com",
            phone: "+91 9876543210",
            orderId: "#ORD_001",
            productId: "#PRD_001",
            rating: 5,
            review: "Excellent product, fast delivery!",
            date: "20 Oct 2025",
        },
        {
            id: 2,
            name: "Bob Smith",
            email: "bob.smith@example.com",
            phone: "+91 9123456789",
            orderId: "#ORD_002",
            productId: "#PRD_003",
            rating: 4,
            review: "Good quality but packaging could be better.",
            date: "18 Oct 2025",
        },
        {
            id: 3,
            name: "Carol Williams",
            email: "carol.williams@example.com",
            phone: "+91 9988776655",
            orderId: "#ORD_003",
            productId: "#PRD_007",
            rating: 3,
            review: "Average experience. Expected faster delivery.",
            date: "16 Oct 2025",
        },
    ]);
    const columns = [
        { id: "srNo", label: "Sr. No." },
        { id: "userDetails", label: "User Details" },
        { id: "rating", label: "Rating" },
        { id: "review", label: "Review" },
        { id: "date", label: "Date" },
    ];
    return (
        <>
            <div className="main_title">
                <h1>View Service</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/manage-vendors/view-vendor")}>
                       View Vendor
                    </button>{" "}
                    - View Service
                </p>
            </div>
            <Box className="custom_tabs1" sx={{ width: "100%" }}>
                <Tabs
                    value={valueTabs}
                    onChange={handleChangeTabs}
                    className="custom_tabs_links"
                >
                    <Tab label="Service Details" {...a11yProps(0)} />
                    <Tab label="Rating & Reviews" {...a11yProps(1)} />
                </Tabs>
            </Box>

            <CustomTabPanel value={valueTabs} index={0}>
                <div className="cards">
                    <div className="view_page">
                        <div className="gap_p">
                            <div className="w_100 vew_img no_radius" >
                                <figure>
                                    <img src="/static/images/placeholder.png" alt="" />
                                </figure>
                            </div>
                            <div className="w_33">
                                <h6>Service Name</h6>
                                <p><strong>Product Description Bundle (20 Items)</strong></p>
                            </div>

                            <div className="w_33">
                                <h6>Provider</h6>
                                <p>Creative Content Ltd.</p>
                            </div>

                            <div className="w_33">
                                <h6>Service Description</h6>
                                <p>
                                    High-quality English & Arabic product descriptions crafted to boost
                                    conversions and improve SEO ranking.
                                </p>
                            </div>

                            <div className="w_33">
                                <h6>Delivery Timeline</h6>
                                <p>2 days delivery</p>
                            </div>

                            <div className="w_33">
                                <h6>Scheduled Date</h6>
                                <p>05 Dec 2025</p>
                            </div>

                            <div className="w_33">
                                <h6>Scheduled Time</h6>
                                <p>14:00</p>
                            </div>

                            <div className="w_33">
                                <h6>Amount</h6>
                                <p><strong>AED 250</strong></p>
                            </div>

                            <div className="w_33">
                                <h6>Status</h6>
                                <p style={{ color: "#d39e00" }}>Pending</p>
                            </div>

                            <div className="w_33">
                                <h6>Payment Status</h6>
                                <p style={{ color: "green" }}>Paid</p>
                            </div>

                        </div>
                    </div>

                </div>
                <div className="cards mt_20">
                    <div className="title_inner">
                        <h3>Vendor Rating</h3>
                    </div>

                    <div className="view_page mt_20">
                        <div className="gap_p">

                            {/* User Rating */}
                            <div className="w_33">
                                <h6> Rating</h6>
                                <p style={{ fontSize: "20px", color: "#ffb400" }}>
                                    ★★★★☆ <span style={{ color: "#000", fontSize: "16px" }}>4.0</span>
                                </p>
                            </div>

                            {/* User Review */}
                            <div className="w_100 mt_10">
                                <h6> Review</h6>
                                <p>
                                    The descriptions were well written and delivered on time.
                                    I liked the quality and attention to detail. Good service!
                                </p>
                            </div>

                            {/* Provider Reply to Rating */}
                            <div className="w_100 mt_20">
                                <h6>Service Provider's Reply</h6>
                                <p>
                                    Thank you for your positive feedback!
                                    We're glad you liked the service.
                                    Feel free to reach out if you need more content.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cards">
                    <div className="title_inner">
                        <h3>Service Provider's Submission</h3>
                    </div>
                    <div className="view_page mt_10">
                        <div className="gap_p">
                            <div className="w_100">
                                
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate quibusdam deleniti quam cum alias id odio laborum fuga, praesentium sapiente itaque enim hic, exercitationem, autem eveniet consequuntur reprehenderit! Repellat, quasi.</p>
                            </div>
                        </div>
                    
                    </div>
                    <div className="title_inner mt_20">
                        <h3>Vendor Reply</h3>
                    </div>
                    <div className="view_page mt_10">
                        <div className="gap_p">
                            <div className="w_100">
                                
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate quibusdam deleniti quam cum alias id odio laborum fuga, praesentium sapiente itaque enim hic, exercitationem, autem eveniet consequuntur reprehenderit! Repellat, quasi.</p>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </CustomTabPanel>
            <CustomTabPanel value={valueTabs} index={1}>
                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow hover>
                                {columns.map((column) => (
                                    <TableCell key={column.id}>{column.label}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows.map((row, index) => (
                                <TableRow hover key={row.id}>
                                    <TableCell>{index + 1}</TableCell>

                                    {/* User Details */}
                                    <TableCell>
                                        <a
                                            href="/manage-customers/details"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate("/manage-customers/details");
                                            }}
                                            className="user_block click_action"
                                        >
                                            <figure>
                                                <img
                                                    src="/static/images/user_placeholder.png"
                                                    alt="User"
                                                />
                                            </figure>
                                            <p>
                                                <b>{row.name}</b>
                                                {row.email}
                                                <br />
                                                {row.phone}
                                            </p>
                                        </a>
                                    </TableCell>

                                    {/* Rating */}
                                    <TableCell>
                                        {"⭐".repeat(row.rating)}
                                        {row.rating < 5 ? "☆".repeat(5 - row.rating) : ""}
                                    </TableCell>

                                    <TableCell className="max_c2">{row.review}</TableCell>
                                    <TableCell>{row.date}</TableCell>

                                    {/* Actions */}
                                </TableRow>
                            ))}

                            {rows.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No records found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CustomTabPanel>

        </>
    );
};

export default ViewPurchaseServices;
